import React from "react";
import { Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import Header from "./Header";
import JobDescription from "./JobDescription";
import RightSection from "./RightSection";
import { useLocation, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


const JobOverview = () => {
  const { t } = useTranslation();
  document.title = t("job_overview.title");

  const { state } = useLocation();
  const jobData = state?.job;

  if (!jobData) {
    return <Navigate to="/apps-job-lists" replace />;
  }

  return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid style={{ padding: '0 30px' }}>
            <BreadCrumb title={t("job_overview.title")} pageTitle={t("job_overview.page_title")} />
            <Row style={{ padding: '15px 0 3px' }}>
              <Header job={jobData} />
            </Row>
            <Row className="mt-n5">
              <Col xxl={9}>
                <JobDescription job={jobData} />
              </Col>
              <Col xxl={3}>
                <RightSection job={jobData} />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  );
};

export default JobOverview;